export const ORDERS_GRID = 'orders';
export const SHIPPINGS_GRID = 'shippings';
export const POOLING_BUTTONS_FIELD_NAME = 'sendToPoolingShipping';
export const AUTOGROUPING_GRID = 'autogrouping';
export const AUTOGROUPING_ORDERS_GRID = 'autogroupingOrders';
